import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Container,
  CssBaseline,
  Paper,
  Link,
} from "@mui/material";
import "./LoginPage.css"; // Import the CSS file
import { setAccessToken, validateEmpty } from "../../utils/utils";
import Config from "../../utils/Config";
import { callPostWithValueRestApis } from "../../Services/Api";
import { LockOutlined, PersonOutlineOutlined } from "@mui/icons-material";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [wrongCred, setWrongCred] = useState(false);

  const handleValidation = () => {
    let checkValidation = ["Username", "Password"];
    checkValidation.forEach((item) => {
      let { valid, errMsg } = validateEmpty(
        item,
        item === "Username" ? username : password,
        true
      );
      if (!valid) {
        item === "Username"
          ? setUsernameError(errMsg)
          : setPasswordError(errMsg);
      }
    });
  };

  const handleLogin = async () => {
    handleValidation();
    let userObj = {
      username: username,
      password: password,
    };
    if (username && password) {
      await callPostWithValueRestApis(Config.LOGIN, userObj)
        .then((res) => {
          let userData = res?.data;
          if (userData === "wrong credentials!!") {
            setWrongCred(true);
          } else {
            let { token } = userData;
            setAccessToken(token);
            window.location.href = "/dashboard";
          }
        })
        .catch((err) => {
          console.log(err, "eee");
        });
    }
  };

  return (
    <div className="root" style={{ overflow: "hidden" }}>
      <CssBaseline />
      <Container
        component="main"
        maxWidth="xl"
        style={{ overflow: "hidden", margin: "0px", padding: "0px" }}
      >
        <div className="content">
          <div className="left">
            <div class="left-div">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="207.28"
                height="230.42"
                viewBox="0 0 208 464"
                fill="none"
              >
                <path
                  d="M140.603 303.418L140.053 303.059H137.734V290.383H136.635C137.304 289.187 137.734 287.824 137.734 286.341C137.734 283.805 136.563 281.581 134.77 280.05C136.563 278.52 137.734 276.295 137.734 273.76C137.734 271.249 136.587 269.048 134.842 267.518C136.611 266.011 137.734 263.786 137.734 261.275C137.734 257.879 135.678 254.961 132.738 253.693C131.757 241.639 118.345 235.803 105.196 235.253V1.29156H102.016V235.229C88.5556 235.54 74.5455 241.352 73.5413 253.693C70.6006 254.961 68.5446 257.879 68.5446 261.275C68.5446 263.786 69.6921 265.987 71.4374 267.518C69.6682 269.024 68.5446 271.249 68.5446 273.76C68.5446 276.295 69.7161 278.52 71.4852 280.05C69.6921 281.581 68.5446 283.805 68.5446 286.341C68.5446 287.824 68.9749 289.187 69.6443 290.383H68.5446V303.059H66.2255L65.6756 303.418C47.386 315.855 36.4839 336.496 36.4839 358.572C36.4839 395.333 66.3928 425.254 103.139 425.254C139.886 425.254 169.795 395.333 169.795 358.572C169.795 336.472 158.893 315.855 140.603 303.418ZM76.8167 277.802C74.5933 277.802 72.7763 275.984 72.7763 273.76C72.7763 271.536 74.5933 269.718 76.8167 269.718H129.462C131.686 269.718 133.503 271.536 133.503 273.76C133.503 275.984 131.686 277.802 129.462 277.802H76.8167ZM103.139 239.438C103.163 239.438 103.163 239.438 103.139 239.438C114.52 239.438 126.737 243.672 128.41 252.88H77.8926C79.5662 243.648 91.7832 239.438 103.139 239.438ZM76.8167 257.233H129.462C131.686 257.233 133.503 259.051 133.503 261.275C133.503 263.499 131.686 265.317 129.462 265.317H76.8167C74.5933 265.317 72.7763 263.499 72.7763 261.275C72.8002 259.051 74.5933 257.233 76.8167 257.233ZM72.8002 286.317C72.8002 284.092 74.6172 282.275 76.8406 282.275H129.486C131.71 282.275 133.527 284.092 133.527 286.317C133.527 288.541 131.71 290.359 129.486 290.359H76.8167C74.5933 290.359 72.8002 288.541 72.8002 286.317ZM72.8002 294.592H76.8406H129.486H133.527V303.035H72.8002V294.592ZM102.853 351.444C100.94 349.268 98.334 347.593 95.0825 347.067C93.9349 346.876 92.8351 346.756 91.7832 346.708C97.2342 333.721 99.4337 314.061 100.055 307.245H106.463C107.084 314.013 109.26 333.482 114.639 346.493C113.396 346.517 112.081 346.637 110.694 346.852C107.347 347.426 104.717 349.172 102.853 351.444ZM103.737 362.542C103.642 363.666 103.307 364.264 103.092 364.264C102.853 364.264 102.446 363.57 102.327 362.279C102.231 361.107 102.422 359.48 102.948 357.83C103.594 359.552 103.857 361.25 103.737 362.542ZM103.163 420.996C68.7358 420.996 40.7395 392.989 40.7395 358.548C40.7395 338.074 50.757 318.94 67.5404 307.268H68.5446H96.8517C95.8954 317.29 93.1937 335.802 88.2926 346.804C82.1721 347.378 77.9165 350.248 76.243 353.31C75.2866 355.08 75.3105 356.826 76.3386 357.95C77.0558 358.739 78.8728 359.839 82.8177 358.189C85.7583 356.945 88.2448 353.908 90.3009 349.866C91.6158 349.842 93.0264 349.937 94.5565 350.2C97.3777 350.655 99.5055 352.233 101.012 354.219C99.5772 356.969 98.9795 360.031 99.1708 362.542C99.4576 366.153 101.394 367.445 103.092 367.445C104.765 367.445 106.63 366.225 106.917 362.805C107.132 360.27 106.415 357.065 104.789 354.195C106.224 352.162 108.304 350.511 111.22 350.033C112.966 349.746 114.615 349.65 116.098 349.722C118.178 353.86 120.688 356.969 123.676 358.213C127.358 359.767 129.128 358.954 129.988 358.021C130.992 356.921 131.016 355.223 130.06 353.453C128.602 350.798 124.513 347.522 118.154 346.708C113.276 335.682 110.575 317.29 109.642 307.292H137.758H138.762C155.57 318.988 165.587 338.122 165.587 358.572C165.563 392.989 137.567 420.996 103.163 420.996ZM86.4995 350.296C85.0411 352.736 83.3915 354.506 81.5984 355.271C79.5901 356.132 78.825 355.869 78.7533 355.869C78.7055 355.725 78.7533 355.008 79.6857 353.932C80.905 352.473 83.2241 350.99 86.4995 350.296ZM119.971 350.248C122.911 350.99 125.087 352.353 126.402 353.788C127.502 354.984 127.597 355.821 127.669 355.821C127.502 355.917 126.665 355.988 124.896 355.247C123.079 354.506 121.453 352.736 119.971 350.248Z"
                  fill="#EAEAEA"
                />
                <path
                  d="M104.359 462.708C103.689 462.708 103.163 462.182 103.163 461.513V448.023C103.163 447.353 103.689 446.827 104.359 446.827C105.028 446.827 105.554 447.353 105.554 448.023V461.513C105.554 462.158 105.028 462.708 104.359 462.708Z"
                  fill="#EAEAEA"
                />
                <path
                  d="M31.9174 432.692C31.6066 432.692 31.2958 432.572 31.0807 432.333C30.6025 431.855 30.6025 431.113 31.0807 430.635L40.62 421.092C41.0981 420.614 41.8393 420.614 42.3174 421.092C42.7956 421.57 42.7956 422.312 42.3174 422.79L32.7781 432.333C32.5391 432.572 32.2283 432.692 31.9174 432.692Z"
                  fill="#EAEAEA"
                />
                <path
                  d="M167.261 297.271C166.95 297.271 166.639 297.151 166.424 296.912C165.946 296.434 165.946 295.692 166.424 295.214L175.963 285.671C176.441 285.193 177.183 285.193 177.661 285.671C178.139 286.149 178.139 286.891 177.661 287.369L168.121 296.912C167.882 297.151 167.572 297.271 167.261 297.271Z"
                  fill="#EAEAEA"
                />
                <path
                  d="M15.3969 360.222H1.91281C1.24338 360.222 0.717407 359.696 0.717407 359.026C0.717407 358.356 1.24338 357.83 1.91281 357.83H15.3969C16.0664 357.83 16.5923 358.356 16.5923 359.026C16.5923 359.672 16.0425 360.222 15.3969 360.222Z"
                  fill="#EAEAEA"
                />
                <path
                  d="M206.805 360.222H193.321C192.651 360.222 192.125 359.696 192.125 359.026C192.125 358.356 192.651 357.83 193.321 357.83H206.805C207.474 357.83 208 358.356 208 359.026C208 359.672 207.474 360.222 206.805 360.222Z"
                  fill="#EAEAEA"
                />
                <path
                  d="M41.4568 297.271C41.146 297.271 40.8351 297.151 40.62 296.912L31.0807 287.369C30.6025 286.891 30.6025 286.149 31.0807 285.671C31.5588 285.193 32.3 285.193 32.7781 285.671L42.3174 295.214C42.7956 295.692 42.7956 296.434 42.3174 296.912C42.0545 297.151 41.7676 297.271 41.4568 297.271Z"
                  fill="#EAEAEA"
                />
                <path
                  d="M176.8 432.692C176.489 432.692 176.178 432.572 175.963 432.333L166.424 422.79C165.946 422.312 165.946 421.57 166.424 421.092C166.902 420.614 167.643 420.614 168.121 421.092L177.661 430.635C178.139 431.113 178.139 431.855 177.661 432.333C177.422 432.572 177.111 432.692 176.8 432.692Z"
                  fill="#EAEAEA"
                />
                <path
                  d="M64.7909 454.744C64.6474 454.744 64.4801 454.72 64.3366 454.648C63.7389 454.385 63.4281 453.692 63.6911 453.094L68.9031 440.656C69.1661 440.059 69.8594 439.772 70.4571 440.011C71.0548 440.274 71.3656 440.967 71.1026 441.565L65.8907 454.002C65.6994 454.481 65.269 454.744 64.7909 454.744Z"
                  fill="#EAEAEA"
                />
                <path
                  d="M9.56339 399.064C9.08523 399.064 8.65488 398.777 8.46362 398.322C8.22454 397.701 8.51144 397.007 9.10914 396.768L21.5891 391.65C22.1868 391.41 22.9041 391.697 23.1432 392.295C23.3822 392.917 23.0953 393.611 22.4976 393.85L10.0176 398.968C9.87419 399.04 9.70684 399.064 9.56339 399.064Z"
                  fill="#EAEAEA"
                />
                <path
                  d="M186.674 326.474C186.196 326.474 185.766 326.187 185.574 325.733C185.335 325.111 185.622 324.417 186.22 324.178L198.7 319.06C199.298 318.821 200.015 319.108 200.254 319.706C200.493 320.327 200.206 321.021 199.608 321.26L187.128 326.379C186.985 326.426 186.841 326.474 186.674 326.474Z"
                  fill="#EAEAEA"
                />
                <path
                  d="M22.3063 325.828C22.1629 325.828 21.9955 325.805 21.8521 325.733L9.41988 320.519C8.82218 320.256 8.51138 319.562 8.77437 318.964C9.03736 318.342 9.73069 318.079 10.3284 318.318L22.7606 323.532C23.3583 323.795 23.6691 324.489 23.4061 325.087C23.2148 325.565 22.7606 325.828 22.3063 325.828Z"
                  fill="#EAEAEA"
                />
                <path
                  d="M198.867 399.781C198.724 399.781 198.556 399.758 198.413 399.686L185.981 394.472C185.383 394.209 185.072 393.515 185.335 392.917C185.598 392.319 186.292 392.032 186.889 392.271L199.321 397.485C199.919 397.748 200.23 398.442 199.967 399.04C199.776 399.518 199.321 399.781 198.867 399.781Z"
                  fill="#EAEAEA"
                />
                <path
                  d="M143.209 455.055C142.731 455.055 142.301 454.768 142.109 454.313L136.993 441.828C136.754 441.207 137.041 440.513 137.639 440.274C138.236 440.035 138.954 440.322 139.193 440.92L144.309 453.405C144.548 454.026 144.261 454.72 143.664 454.959C143.52 455.007 143.353 455.055 143.209 455.055Z"
                  fill="#EAEAEA"
                />
              </svg>
            </div>
            <div
              className="resume-builder"
              style={{
                fontFamily: "Noto Sans",
                color: "white",
                fontSize: "48px",
                fontWeight: 700,
                lineHeight: "60px",
                letterSpacing: "-0.02em",
                textAlign: "center",
                width: "648px",
                height: "auto",
                gap: "0px",
                opacity: "1",
              }}
            >
              <p
                className="builder-text"
                style={{ textAlign: "center", marginBottom: "-22px" }}
              >
                Welcome to Resume Builder
              </p>
              <p
                className="future-text"
                style={{ textAlign: "center", marginBottom: "-35px" }}
              >
                The future of recruiting starts here.
              </p>
            </div>
            <div
              style={{
                marginLeft: "260px",
                color: "white",
                width: "148.66px",
                top: "1.05px",
                gap: "0px",
                opacity: "0px",
              }}
            >
              <svg
                width="90"
                height="395"
                viewBox="0 0 150 492"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_5_1085)">
                  <path
                    d="M11.0526 492V436.038H137.605V492H148.658V1.05247H137.605V81.4037H11.0526V1.05247H0V492H11.0526ZM11.0526 92.4803H137.605V167.306H11.0526V92.4803ZM11.0526 178.357H137.605V253.183H11.0526V178.357ZM11.0526 264.259H137.605V339.085H11.0526V264.259ZM11.0526 350.136H137.605V424.962H11.0526V350.136Z"
                    fill="#DCDCDC"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_5_1085">
                    <rect width="150" height="492" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="hald_Circle" style={{ marginTop: "-115px" }}>
              <svg
                width="202"
                height="135"
                viewBox="0 0 262 145"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="path-1-inside-1_1_3847" fill="white">
                  <path d="M-69.7597 5.48029C-7.67606 -5.79652 56.3312 0.719365 114.869 24.2753C173.407 47.8313 224.087 87.4662 261.055 138.602L253.113 144.343C217.228 94.7057 168.033 56.2321 111.211 33.3663C54.3881 10.5005 -7.7438 4.17557 -68.0084 15.122L-69.7597 5.48029Z" />
                </mask>
                <path
                  d="M-69.7597 5.48029C-7.67606 -5.79652 56.3312 0.719365 114.869 24.2753C173.407 47.8313 224.087 87.4662 261.055 138.602L253.113 144.343C217.228 94.7057 168.033 56.2321 111.211 33.3663C54.3881 10.5005 -7.7438 4.17557 -68.0084 15.122L-69.7597 5.48029Z"
                  fill="white"
                  stroke="white"
                  stroke-opacity="0.3"
                  stroke-width="16"
                  mask="url(#path-1-inside-1_1_3847)"
                />
              </svg>
            </div>

            <div className="second_Half_Cicle" style={{ marginTop: "-180px" }}>
              <svg
                width="202"
                height="95"
                viewBox="0 0 262 145"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="path-1-inside-1_1_3847" fill="white">
                  <path d="M-69.7597 5.48029C-7.67606 -5.79652 56.3312 0.719365 114.869 24.2753C173.407 47.8313 224.087 87.4662 261.055 138.602L253.113 144.343C217.228 94.7057 168.033 56.2321 111.211 33.3663C54.3881 10.5005 -7.7438 4.17557 -68.0084 15.122L-69.7597 5.48029Z" />
                </mask>
                <path
                  d="M-69.7597 5.48029C-7.67606 -5.79652 56.3312 0.719365 114.869 24.2753C173.407 47.8313 224.087 87.4662 261.055 138.602L253.113 144.343C217.228 94.7057 168.033 56.2321 111.211 33.3663C54.3881 10.5005 -7.7438 4.17557 -68.0084 15.122L-69.7597 5.48029Z"
                  fill="white"
                  stroke="white"
                  stroke-opacity="0.3"
                  stroke-width="16"
                  mask="url(#path-1-inside-1_1_3847)"
                />
              </svg>
            </div>
          </div>
          <div className="right" style={{ width: 471, height: 560 }}>
            <div className="logoSection">
              <img
                alt="QSS Technosoft"
                className="qssTechnosoftImage"
                src="https://s3-alpha-sig.figma.com/img/76d4/20b9/97260d413c4484a7123193abb6fec770?Expires=1715558400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=oEHAej15xbo4-2VBPg4JJryOQfFuo5otz8~O1yN0FDORmzASnRBwSS2SGKiJWjBh92MgDd-jJXN~Vcml4I1tqUHGzuEt39rG1act9xslApCL1ESJMVLC0yZ2HIEWvizNCM-oR9VbZ86gmX~Ook8RrnMEblB7Y-QhVoSm1Kzr8CCQLewitPX2K3oB4mOmlGrZzwN0E7qQjNQ02ZgeO3aCAkxWyne2PgYbLRu7~mMLuRYlho9X1B4MAbE5Ro7ooSEqcjrtHfRtNi9tustNZ4tsucsOHzLZGKfeuFY3voEP1KIw1OomjjRZLyvegxzwqAdbpAd1lJG7pK9Yv4aJZfWeNw__"
              />
            </div>
            <Paper
              className="paper"
              style={{ height: 560, width: 471, boxShadow: "none" }}
            >
              <Typography
                variant="h6"
                align="center"
                gutterBottom
                style={{
                  color: "red",
                  fontFamily: "Noto Sans",
                  fontSize: 36,
                  fontWeight: 600,
                  lineHeight: "44px",
                  letterSpacing: "-0.02em",
                  textAlign: "left",
                }}
              >
                Log in
              </Typography>

              <form className="form" noValidate>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="username"
                  label="Username"
                  name="username"
                  autoComplete="username"
                  autoFocus
                  value={username}
                  onChange={(e) => {
                    setUsername(e.target.value);
                    setUsernameError("");
                    setWrongCred(false);
                  }}
                  error={usernameError ? true : false}
                  helperText={usernameError}
                  InputProps={{
                    startAdornment: (
                      <PersonOutlineOutlined style={{ marginRight: "8px" }} />
                    ),
                  }}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setPasswordError("");
                    setWrongCred(false);
                  }}
                  error={passwordError ? true : false}
                  helperText={passwordError}
                  InputProps={{
                    startAdornment: (
                      <LockOutlined style={{ marginRight: "8px" }} />
                    ),
                  }}
                />
                {wrongCred && (
                  <label className="wrongCred">
                    Incorrect username or password
                  </label>
                )}
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="error"
                  className="submit"
                  onClick={handleLogin}
                >
                  Log In
                </Button>
              </form>
            </Paper>
            <Typography
              variant="body2"
              color="textSecondary"
              className="footer"
            >
              Developed by{" "}
              <Link
                href="https://www.qsstechnosoft.com/"
                target="_blank"
                rel="noopener"
              >
                QSS Technosoft
              </Link>
            </Typography>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default LoginPage;
